export default __webpack_public_path__ + "static/media/video-placeholder.f7ab7353.png";